import { Component, input } from '@angular/core';
import { TableModule } from 'primeng/table';
import { Skeleton } from "primeng/skeleton";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'gate-generic-table-skeleton',
  imports: [TableModule, Skeleton, CommonModule],
  templateUrl: './generic-table-skeleton.component.html',
  styleUrl: './generic-table-skeleton.component.scss',
})
export class GenericTableSkeletonComponent {
  // Configuration inputs
  columns = input<SkeletonTableColumn[]>([]);
  rows = input<number>(5); // Number of skeleton rows to show
  showCaption = input<boolean>(false); // Whether to show caption skeleton
  captionWidth = input<string>('14rem'); // Width of caption skeleton
  captionActionCount = input<number>(1); // Number of right-side caption action skeletons
  showActions = input<boolean>(true); // Whether to show action column
  actionType = input<'circle' | 'button'>('circle'); // Type of action skeleton
  
  // Generate array for skeleton rows
  get skeletonRows(): number[] {
    return Array.from({ length: this.rows() }, (_, i) => i + 1);
  }
}

export interface SkeletonTableColumn {
  headerWidth?: string; // width of header skeleton (default: '6rem')
  cellWidth?: string;   // width of cell skeleton (default: '6rem')
  cellHeight?: string;  // height of cell skeleton (default: '1rem')
  width?: string;       // column width percentage (e.g., '20%')
}
